import { Player } from "../classes/Player";
import { NUM_OF_AVATARS, NUM_OF_TRIES } from "../constants/Constants";
import { Genders } from "../constants/Genders";

export const getAvatar = (players: Player[]) => {
  for (let tryNum = 0; tryNum < NUM_OF_TRIES; tryNum++)
    {
        const avatarIdx = Math.floor(Math.random() * NUM_OF_AVATARS);
        const avatar = String(avatarIdx);
        const idx = players.findIndex((p) => p.isActive() && p.image === avatar);
        if (idx === -1)
        {
            return avatar;
        }
    }
    for (let idx = 0; idx < NUM_OF_AVATARS; idx++)
    {
        const avatar = String(idx);
        const idx1 = players.findIndex((p) => p.isActive() && p.image === avatar);
        if (idx1 === -1)
        {
            return avatar;
        }
    }
    return ""; // no more avatars
}

export const getCriminalImageSubPath = (gender: Genders) => {
    if (gender === Genders.male) {
        return "maleWinningCards";
    }
    if (gender === Genders.female) {
        return "femaleWinningCards";
    }
    return "otherWinningCards";
}